var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('h2',[_vm._v("downlink")]),_vm._v(" "),_c('canble-chart',{attrs:{"set":_vm.$root.downlink}}),_vm._v(" "),_c('h2',[_vm._v("rtt")]),_vm._v(" "),_c('canble-chart',{attrs:{"set":_vm.$root.rtt}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10791a22","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 